export default __webpack_public_path__ + "static/flask-60dae2a0e84e89678408e54db68c5274.svg";